// extracted by mini-css-extract-plugin
module.exports = {"gridRow":"_1P7F31nfhKxrHBhhxe-3kT","extract":"_1l8K5XD9XOppMSaQz4l10h","listProducts":"Do0dW6P4MmdsA7-2cD2YV","center":"_1DgEnf4AWNuPyVCOLu8fUK"};